import { Box, CircularProgress, Paper } from '@mui/material';
import React, { useEffect, useState } from 'react';
import DataList from '../../sharedcomponents/dataList/dataList';
import APIURLConstants from '../../config/config';
import Helper from '../../utility/helper';
import ApiHelper from '../../utility/ApiHelper';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(() => ({
    loader: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%',
        width: '100%',
    },
}));

const ContactList = () => {
    const classes = useStyles();
    const [userConnections, setUserConnections] = useState([]);
    const [participants, setParticipants] = useState([]);
    const [selectedUser, setSelectedUser] = useState(0);
    const [loading, setLoading] = useState(true);
    const eventInfo = Helper.getStorage('eventInfo');
    const userInfo = Helper.getStorage('userInfo');
    const [selectedUserName, setSelectedUserName] = useState('');

    useEffect(() => {
        getParticipantList(true)
    }, [])
    const getUserName = (data) => {
        setSelectedUserName(data && data.name)
    }
    const getParticipantList = (loader) => {
        loader ? setLoading(true) : null
        ApiHelper.get(
            APIURLConstants.GET_EVENT_PARTICIPANTS(
                eventInfo.eventID, 1, 5000, 1
            )
        )
            .then((res) => {
                if (res.data) {
                    setLoading(false)
                    if (res.data.rows.length > 0) {
                        let rowData = res.data.rows;
                        getUserName(rowData[0])
                        if (selectedUser === 0) {
                            showOnclickUserConnections(rowData[0].linkedWith)
                            setSelectedUser(rowData[0].userID)
                        } else {
                            setSelectedUser(selectedUser)
                            const selectedParti = rowData.filter((val) => val.userID === selectedUser)
                            showOnclickUserConnections(selectedParti[0].linkedWith) 
                        }
                        setParticipants(res.data.rows)
                    }
                }
            }).catch((err) => {
                setLoading(false)
                console.log("err", err);
            }
            )
    }
    const showOnclickUserConnections = (data) => {
        if (data.length > 0) {
            let usersData = [];
            data.map((item) => {
                usersData.push({
                    actualData: item,
                    row: [
                        {
                            key: 'fromUserID',
                            fromUserID: item.fromUserID,
                        },
                        {
                            key: 'userID',
                            userID: item.userID,
                        },
                        {
                            label: 'Name',
                            key: 'name',
                            name: item.name,
                            showLabel: false,
                            width: '0.4',
                            inColumn: true,
                            toEmail: item.email,
                            showEmail: true,
                        },
                        {
                            label: 'Priority',
                            key: 'priority',
                            priority: String(item.priority),
                            width: '0.29',
                            inColumn: true,
                            showChips: true,
                            wrapUp: true,
                        },

                        {
                            label: 'Hidden',
                            key: 'hide',
                            hide: item.hide === true ? true : false,
                            inColumn: true,
                            showLabel:true,
                            width: '0.3',
                            alignRight:true
                        },
                    ],
                });
            });
            setUserConnections(usersData)
        } else {
            setUserConnections([])
        }
    }
    const contactHandleUserClick = (id) => {
        let data = participants.filter((x) =>
            x.userID === id
        );
        getUserName(data[0])
        if (data[0].linkedWith.length > 0) {
            showOnclickUserConnections(data[0].linkedWith)
        } else {
            showOnclickUserConnections([])
        }
        setSelectedUser(id);
    }
    const onDragEnd = ({ destination, source }) => {
        if (!destination) return;
        reorder(source.index, destination.index);
    };
    const reorder = (startIndex, endIndex) => {
        const newModuleList = [...userConnections];
        const [removed] = newModuleList.splice(startIndex, 1);
        newModuleList.splice(endIndex, 0, removed);
        let data = [];
        let moduleData = [];
        newModuleList.forEach((item, index) => {
            const row = item.actualData;
            // console.log("row", row);
            moduleData.push(row);
            data.push({
                PrimaryuserID: row.userID,
                ConnectedTo: row.fromUserID,
                priority: index + 1,
                isHide: row.hide
            });
        });
        // console.log("newModuleList", newModuleList, data);
        setUserConnections(newModuleList);
        // setDrawerOpen(moduleData);
        updateContactListOrder({
            eventID: eventInfo.eventID,
            createdBy: userInfo.eventID,
            connections: data
        });
    };

    const updateContactListOrder = (data) => {
        ApiHelper.post(APIURLConstants.UPDATE_CONTACT_LIST_ORDERS, data)
            .then((res) => {
                if (res.data) {
                    getParticipantList(false)
                }
            })
            .catch((error) => {
                console.log(error);
            });
    };
    const onCheckContactSelect = (event, index, item) => {
        console.log(event.target.checked, index, item);
        let newFilterList = [...userConnections];
        newFilterList[index]['hide'] = event.target.checked;
        setUserConnections(newFilterList);
        const data = {
            eventID: eventInfo.eventID,
            createdBy: userInfo.eventID,
            connections: [{
                PrimaryuserID: item.actualData.userID,
                ConnectedTo: item.actualData.fromUserID,
                priority: item.actualData.priority,
                isHide: event.target.checked
            }]
        }
        updateContactListOrder(data);
    }
    // console.log("userConnections", userConnections);
    return (
        <>
            {loading ? (
                <Box
                    sx={
                        loading
                            ? { paddingTop: '20%', paddingBottom: '20%' }
                            : ''
                    }
                    className={classes.loader}>
                    <CircularProgress />
                </Box>
            ) : (
                <Paper sx={{ width: '100%', mb: 2, boxShadow: 'none', maxHeight: 'calc(100vh - 70px)', }}>
                    {userConnections && (
                        <DataList
                            data={userConnections}
                            contactParticipants={participants}
                            contactHandleUserClick={contactHandleUserClick}
                            title={''}
                            isDraggable={true}
                            showUsersList={true}
                            onDragEnd={onDragEnd}
                            selectedUser={selectedUser}
                            onCheckContactSelect={onCheckContactSelect}
                            showCheckBoxes={true}
                            showUserName={true}
                            selectedUserName={selectedUserName}
                            showTopbar={false}
                            hideToolBar={true}
                        />)}

                </Paper>
            )}
        </>
    )

}

export default ContactList